require("jquery-bar-rating");

var StarRating = Backbone.View.extend({
  initialize: function() {
    this.settings = {
      currentRating: null,
      readOnly: false
    };

    if (this.$el.data("settings")) {
      this.settings = $.extend(
        true,
        this.settings,
        eval(this.$el.data("settings"))
      );
    }

    require("../../../../../../build/node_modules/jquery-bar-rating/dist/themes/fontawesome-stars.css");
    require("../../../../../../build/node_modules/jquery-bar-rating/dist/themes/fontawesome-stars-o.css");

    var options = {
      theme: this.settings.readOnly
        ? "fontawesome-stars-o"
        : "fontawesome-stars",
      allowEmpty: true,
      emptyValue: 0,
      readonly: this.settings.readOnly,
      initialRating: this.settings.currentRating,
      showSelectedRating: true
    };

    this.$("select").barrating(options);
  }
});

module.exports = StarRating;
